<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">


        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-muted">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()"><i class="fa fa-file-text-o fa-1x push-5-r"></i>  {{labelTitleBanner[actualLanguage]}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Unit Detail Information  -->
                    <div  class="block">

                        <h6 class="push">{{labelExplanation[actualLanguage]}}</h6>
                        <h6 class="push">{{labelExplanation1[actualLanguage]}}</h6>
                        <h6 class="push">{{labelExplanation2[actualLanguage]}}</h6>
                        <h6 class="push">{{labelExplanation3[actualLanguage]}}</h6>


                        <h2 class="block-title push">{{labelAddTitle[actualLanguage]}}</h2>
                        
                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-3">
                              <h6>{{labelListName[actualLanguage]}}</h6>
                              <input v-model="listName" class="form-control align-left " type="test"  placeholder="">
                          </div>
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelListDescription[actualLanguage]}}</h6>
                              <input v-model="listDescription" class="form-control align-left" type="test"  placeholder="">
                          </div>
                          <div class="col-xs-12 col-sm-3">
                            <h6 style="color:white;">-</h6>
                            <button  type="button" @click="addMessageList()" class="btn btn-block btn-default margin-bottom" name="buttonAddPlanItem">
                              <spinner size="small" v-if="listIsSaving"></spinner>
                              <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddList[actualLanguage] }}</span></button>
                          </div>

                        </div>

                        


                      <h2 class="block-title push">{{labellistListTitle[actualLanguage]}}</h2>
                        
                      <div v-if="flagDisplaySectionMessageList" class="block-content">
                        <div v-for ="(messageList,index) in listList" class="block block-bordered">
                          <div class="block-header bg-gray-lighter">
                              <ul class="block-options">
                                  <li>
                                      <button type="button" @click="toggleDisplayMessageList(index)"><i class="fa fa-file-text-o"></i></button>
                                  </li>
                              </ul>
                              <h3 class="block-title" @click="toggleDisplayMessageList(index)">{{messageList.referenceName}}</h3>
                          </div>

                          <div v-if="messageListOpenFlag[index]" class="block-content">
                              <h6 class="push">{{messageList.description}}</h6>
                              <div v-for ="(level,index2) in messageList.compareLevelList" class="row push">
                                
                                <div class="col-xs-12 col-md-12" >
                                  <div class="col-xs-12 col-sm-2">
                                      <h6>{{labelRangeStart[actualLanguage]}}</h6>
                                      <input v-model="level.rangeStart" class="form-control align-left " type="test"  placeholder="">
                                  </div>
                                  <div class="col-xs-12 col-sm-2">
                                      <h6>{{labelRangeEnd[actualLanguage]}}</h6>
                                      <input v-model="level.rangeEnd" class="form-control align-left " type="test"  placeholder="">
                                  </div>
                                  <div class="col-xs-12 col-sm-6">
                                      <h6>{{labelRangeMessage[actualLanguage]}}</h6>
                                      <input v-model="level.message" class="form-control align-left " type="test"  placeholder="">
                                  </div>
                                  <div class="col-xs-12 col-sm-2">
                                    <h6 style="color:white;">-</h6>
                                    <div class="btn-group">
                                                    <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                    @click="deleteMessageLine(index,index2)" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                    </div>
                                  </div>
                                </div>

                              </div>

                              <div class="row push">
                                  <div class="col-xs-12 col-sm-12 push">
                                    <button  type="button" @click="addMessageLine(index)" class="btn btn-xs align-right" name="buttonAddPlanItem">
                                    <i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddLine[actualLanguage] }}</button>
                                  </div>

                                  <div class="col-xs-12 col-sm-6">
                                    <button  type="button" @click="deleteMessageList(index)" class="btn btn-danger align-left" name="buttonAddPlanItem">
                                    <i class="fa fa-trash fa-1x push-5-r "></i>{{ labelButtonDeleteThisList[actualLanguage] }}</button>
                                  </div>

                                  <div class="col-xs-12 col-sm-6 push">
                                    <button  type="button" @click="saveMessageListModifications(index)" class="btn btn-default align-right" name="buttonAddPlanItem">
                                    <i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</button>
                                  </div>

                              </div>
                        


                          </div>
                        </div>
                      </div>


                    </div>
                    <!-- END Static Labels -->

                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'


export default {
  name: 'UnitType',
 
  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,

      actualLanguage : "FR",
      labelTitleBanner: {FR: "Configurateur des messages de comparaison", EN: 'Comparison message configurator'},

      labelAddTitle: {FR: "Ajouter une liste de message à votre organisation", EN: 'Add a message list to your organization'},

      labelExplanation: {FR: "Les messages de comparaison sont ajouté au rapport de consommation pour féliciter ou soliciter l'attention des consomateurs. Il est possible de créer des messages selon le niveau d'écart par rapport à la moyenne de consommation des consomateurs de même type d'unité.",
                         EN: 'The creation of a unit type makes it possible to compare the consumption of services between units of the same type. You can create a custom list for your organization.'},

      labelExplanation1: {FR: "Il est possible de créer plusieurs liste de message afin de lier les unités a une liste en particulier.",
                         EN: 'It is possible to create several message lists in order to link the units to a particular list.'},

      labelExplanation2: {FR: "Une liste contient une série de condition (plage de comparaison) pour lesquelles on indique un niveau inférieur et supérieur d'écart et le message lié a cette plage.",
                         EN: 'A list contains a series of conditions (comparison range) for which a lower and upper level of difference is indicated and the message linked to this range.'},

      labelExplanation3: {FR: "Il est important de définir les plages dans un ordre croissant de plages, Exemple : -100 à -50, -50 à -25, -25 à 25... Il faut aussi s'assurer de couvrir la plage 0% puisque celle-ci correspond au cas ou la consommation est égale à la moyenne des autres unités de même type.",
                         EN: 'It is important to define the ranges in increasing order of ranges, Example: -100 to -50, -50 to -25, -25 to 25... You must also make sure to cover the 0% range since this corresponds to the case where consumption is equal to the average of other units of the same type.'},


      labelListName: {FR: "Nom de la liste", EN: 'List name'},
      labelListDescription: {FR: "Description de la liste", EN: 'List description'},
      listName : '',
      listDescription:'',
      listList : [],
      listIsSaving : false,

      labellistListTitle: {FR: "Liste de messages", EN: 'Message list'},

      messageListOpenFlag : [],
      flagDisplaySectionMessageList : 1,

      labelButtonAddList: {FR: "Ajouter la liste", EN: 'Add this list'},

      labelRangeStart : {FR: "Début plage", EN: 'Range start'},
      labelRangeEnd : {FR: "Fin plage", EN: 'Range end'},
      labelRangeMessage : {FR: "Message", EN: 'Message'},

      labelButtonSaveModifications: {FR: 'Enregistrer modifications', EN: 'Save modifications'},
      labelButtonAddLine: {FR: 'Ajouter une ligne de condition', EN: 'Add conditional line'},
      labelButtonDeleteThisList: {FR: 'Supprimer cette liste', EN: 'Delete this list'},

      messageRemoveConfirmA:{FR: "Confirmer la supression de la liste: ", EN: 'Confirm list deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},

      messageErrorWithCondition:{FR: "Erreur de fin de plage a la ligne: ", EN: 'Error with range end at line : '},
      messageErrorWithCondition2:{FR: "Erreur de début-fin de plage a la ligne: ", EN: 'Error with range start-end at line : '},
      messageErrorNotSaving:{FR: "Les modifications ne sont pas enregistrées.", EN: 'Modifications are not saved.'},

    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
      this.getMessageListList()
    },



  addMessageList(){
      this.listIsSaving = true
        var requestData = {'postAction':'AddMessageList',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'listName':this.listName,
                          'language':this.actualLanguage,
                          'listDescription':this.listDescription}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
              this.listIsSaving = false
            if(response.data.Code=='OK'){
                this.listName = ''
                this.listDescription = ''
                this.listList = response.data.MessageListList
                this.buildMessageListOpenFlag()
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },

  getMessageListList(){

        var requestData = {'postAction':'GetMessageList',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.listList = response.data.MessageList
                this.buildMessageListOpenFlag()
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },

  saveMessageListModifications(index){

      var conditionOrderOk = true
      //Validation if all conditions are in ascending order values:
      for(var m = 0;m < this.listList[index].compareLevelList.length-1;m++){
        if(parseFloat(this.listList[index].compareLevelList[m].rangeEnd) != parseFloat(this.listList[index].compareLevelList[m+1].rangeStart)){
          conditionOrderOk = false
          window.alert(this.messageErrorWithCondition[this.actualLanguage]+parseInt(m+1))
        }
      }     

      for(var n = 0;n < this.listList[index].compareLevelList.length;n++){
        if(parseFloat(this.listList[index].compareLevelList[n].rangeEnd) < parseFloat(this.listList[index].compareLevelList[n].rangeStart)){
          conditionOrderOk = false
          window.alert(this.messageErrorWithCondition2[this.actualLanguage]+parseInt(n+1))
        }
      }  

      if(conditionOrderOk){
          var requestData = {'postAction':'SaveMessageListModifications',
                            'bundleId':this.actualBundle.bundle_id,
                            'parentContainer':this.parentContainer,
                            'messageListData':this.listList[index]}

          this.$store.dispatch('sessionStore/postBundle', requestData)
              .then((response) => {
                //console.log(response)
              if(response.data.Code=='OK'){
                  this.listList = response.data.MessageList
                  }
                  else{
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    }
              })
      }else{
        window.alert(this.messageErrorNotSaving[this.actualLanguage])
      }

    },


  deleteMessageList(index){

        var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.listList[index].referenceName, this.messageRemoveConfirmB[this.actualLanguage]);

        if(confirmation=='DELETE'){
            var requestData = {'postAction':'DeleteMessageList',
                              'bundleId':this.actualBundle.bundle_id,
                              'parentContainer':this.parentContainer,
                              'messageListData':this.listList[index]}

            this.flagDisplaySectionMessageList = false
            this.$store.dispatch('sessionStore/postBundle', requestData)
                .then((response) => {
                  //console.log(response)
                  this.buildMessageListOpenFlag()
                  this.flagDisplaySectionMessageList = true
                if(response.data.Code=='OK'){
                    this.listList = response.data.MessageList
                    }
                    else{
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      }
                })
        }
    },


    toggleDisplayMessageList(index){
      this.flagDisplaySectionMessageList=0
      this.messageListOpenFlag[index]=~this.messageListOpenFlag[index]
      this.flagDisplaySectionMessageList=-1
    },

    buildMessageListOpenFlag(){
            this.messageListOpenFlag = []
            for(var m = 0;m < this.listList.length;m++){
              this.messageListOpenFlag.push(0)
              }
    },

  deleteMessageLine(index,index2){
    this.listList[index].compareLevelList.splice(index2,1)
  },

  addMessageLine(index){
    this.listList[index].compareLevelList.push({'rangeStart':'-10','rangeEnd':'10','message':'Message'})
  },


    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// CompCompareLevelMessageDisplay.vue?4c1c4dcb